import { render, staticRenderFns } from "./insurer-policies.vue?vue&type=template&id=536b7f64&scoped=true&"
import script from "./insurer-policies.vue?vue&type=script&lang=js&"
export * from "./insurer-policies.vue?vue&type=script&lang=js&"
import style0 from "./insurer-policies.vue?vue&type=style&index=0&id=536b7f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b7f64",
  null
  
)

export default component.exports